export default __webpack_public_path__ + "static/media/profile_white.4f18ebd9.svg";